var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01256 10.0039C2.71015 5.47917 6.91593 2 12 2C17.0841 2 21.2899 5.47917 21.9874 10.0039C22.0997 10.7331 21.4436 11.3333 20.6477 11.3333H14.8826V12.9264C14.8826 14.5273 15.0534 16.1237 15.3928 17.6934L15.4758 18.0775C15.9146 20.1068 14.2369 22 12 22C9.76313 22 8.08539 20.1068 8.52418 18.0775L8.60722 17.6934C8.94661 16.1237 9.11744 14.5273 9.11744 12.9264V11.3333H3.35232C2.55638 11.3333 1.90031 10.7331 2.01256 10.0039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushroom);
export default __webpack_public_path__ + "static/media/mushroom.731363b6198f7bd16f048f7b04cead72.svg";
export { ForwardRef as ReactComponent };